import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { FasterPediaApp } from "./app/FasterPediaApp";
import "./styles/tokens.css";
import "./styles/themes.css";
import "./styles/global.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("FasterPedia root element was not found");
}

createRoot(root).render(
  <StrictMode>
    <FasterPediaApp />
  </StrictMode>,
);
